export const CHANGE_USER_INFO = 'CHANGE_USER_INFO';
export const CHANGE_HOTEL_BASEINFO = 'CHANGE_HOTEL_BASEINFO';
export const CHANGE_RATE_PLAN = 'CHANGE_RATE_PLAN';
export const CHANGE_LOADING = 'CHANGE_LOADING';
export const CHANGE_LOADING_RATES = 'CHANGE_LOADING_RATES';
export const CHANGE_RATEPLAN_BY_ROOMS = 'CHANGE_RATEPLAN_BY_ROOMS';
export const CHANGE_CODE = 'CHANGE_CODE';
export const CHANGE_RATE_DESCRIPTION = 'CHANGE_RATE_DESCRIPTION';
export const CHANGE_HOTEL_DESCRIPTION = 'CHANGE_HOTEL_DESCRIPTION';